import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TenantSettings } from '../contracts/tenant_settings.interface';

@Injectable({
  providedIn: 'root',
})
export class TenantSettingsService {
  private baseUrl = 'settings/';

  constructor(private http: HttpClient) {}

  get(id: number): Observable<TenantSettings> {
    return this.http.get<TenantSettings>(`${this.baseUrl}${id}`);
  }

  update(id: number | null, tenantSettings: TenantSettings): Observable<TenantSettings> {
    const url = id ? `${this.baseUrl}${id}` : this.baseUrl;
    return this.http.put<TenantSettings>(url, tenantSettings);
  }
}
